import { useState, useRef } from 'react';
import copyEncounter from '../../pics/icons/copyEncounter.png'


const EditStatTextArea = ({value, contentPath, handleChange}) => {
    const [content, setContent] = useState(value)
    const [autoFillOpen, setAutoFillOpen] = useState(false)
    const [copiedNum, setCopiedNum] = useState(false)
    const [showCopiedText, setShowCopiedText] = useState(false)
    const textareaRef = useRef(null);

    function validate(e, type, contentPath, send = false) {
        if(send) {
            let newValue = e.target.value
            handleChange(newValue, type, contentPath)
        } else {
            let newText = e.target.value
            const indexOfCursor = e.target.selectionStart
            // Check if @ is used
            if(newText[indexOfCursor-2] === '{' && newText[indexOfCursor-1] === '@') {
                setAutoFillOpen(true)
            }
           
            // fix pasting syntax if applicable
            setContent(newText.replace('{@{@', '{@'))
        }
    }

    const handleFocus = (e) => { 
        if(e.target.value === 'None' || e.target.value === '--') 
            e.target.select();
    }

    const copyText = async (text) => {
        setShowCopiedText(true)
        setTimeout(() => {
            setShowCopiedText(false)
        }, 1000)


        await navigator.clipboard.writeText(text)
        if(text.includes('@hover'))
            setCopiedNum(0)
        else if(text.includes('@b'))
            setCopiedNum(1)
        else if(text.includes('@i'))
            setCopiedNum(2)
    }

    return (
        <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
            {autoFillOpen && (
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        backgroundColor: '#f8f2d3d7',
                        border: '1px solid #584c47ff',
                        borderRadius: '5px',
                        padding: '5px 5px 5px 5px',
                        width: '70%',
                        margin: '3px 0px 3px 0px',
                        alignItems: 'baseline',
                        color: 'black'
                    }}>

                        <div className={`copyClick ${copiedNum === 0 ? 'copyClicked ': ''}`} onClick={() => copyText('{@hover light}')}>
                            <b style={{textDecoration: 'underline'}}>{'{@hover light}'}</b>
                            <img className={`copyClickIcon ${copiedNum === 0 ? 'copyClickedIcon ': ''}`} src={copyEncounter} style={{width: '15px'}} alt='copy'/>
                        </div>

                        <div className={`copyClick ${copiedNum === 1 ? 'copyClicked ': ''}`} onClick={() => copyText('{@b bolded}')}>
                            <b >{'{@b bolded}'}</b>
                            <img className={`copyClickIcon ${copiedNum === 1 ? 'copyClickedIcon ': ''}`} src={copyEncounter} style={{width: '15px'}} alt='copy'/>
                        </div>

                        <div className={`copyClick ${copiedNum === 2 ? 'copyClicked ': ''}`} onClick={() => copyText('{@i italics}')}>
                            <i>{'{@i italics}'}</i>
                            <img className={`copyClickIcon ${copiedNum === 2 ? 'copyClickedIcon ': ''}`} src={copyEncounter} style={{width: '15px'}} alt='copy'/>
                        </div>
                        
                        <div style={{borderLeft: '1px solid grey', paddingLeft: '10px', cursor: 'pointer'}} onClick={() => setAutoFillOpen(false)}>❌</div>

                    </div>
                    {showCopiedText && <span style={{color: 'black', marginLeft: '5px'}}><i>Copied</i></span>}
                </div>
            )}
            <textarea
                ref={textareaRef}
                className="editBlockBigInput"
                type="text"
                value={content}
                onChange={(e) => validate(e, 'desc', contentPath)}
                onBlur={(e) => validate(e, 'desc', contentPath, true)} 
                onFocus={handleFocus}
            />
        </div>
    )
}

export default EditStatTextArea;